import { ActionIcon, Tooltip } from '@mantine/core';
import { IconEdit } from '@tabler/icons-react';
import { ActionItem } from '../files-table/FilesTable';

type Props = {
  editAction: ActionItem<unknown> | null;
};

export default function EditDocumentControl({ editAction }: Props) {
  if (!editAction) return null;

  const label = editAction.disabled ? (editAction.tooltip ?? 'Edit') : 'Edit';

  return (
    <Tooltip label={label} withArrow>
      <ActionIcon
        variant="subtle"
        c="brand.7"
        bg="brand.0"
        size={20}
        radius={8}
        aria-label="Edit document"
        disabled={editAction.disabled}
        onClick={e => {
          e.stopPropagation();
          editAction.action(undefined);
        }}
      >
        <IconEdit size={16} stroke={1.5} />
      </ActionIcon>
    </Tooltip>
  );
}
